<div fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="20px" class="mt-10">
    <mat-chip-listbox>
        <mat-chip i18n="@@learning-record-note" name="learning-record-note" class="browser-note-chip">Note: Don't forget to log out and close your
            browser.</mat-chip>
    </mat-chip-listbox>
</div>